
import { EnrollmentEventType } from '@/services/db/enrollment/types';
import { CalendarPlus, ArrowRightLeft, Clock, UserMinus, UserPlus, Info } from 'lucide-react';
import React from 'react';

export const getEventIcon = (eventType: EnrollmentEventType) => {
  switch (eventType) {
    case EnrollmentEventType.NEW_ENROLLMENT:
      return React.createElement(CalendarPlus, { className: "h-4 w-4 mr-1" });
    case EnrollmentEventType.PROGRAM_TRANSFER:
      return React.createElement(ArrowRightLeft, { className: "h-4 w-4 mr-1" });
    case EnrollmentEventType.STATUS_CHANGE:
      return React.createElement(Clock, { className: "h-4 w-4 mr-1" });
    case EnrollmentEventType.WITHDRAWAL:
      return React.createElement(UserMinus, { className: "h-4 w-4 mr-1" });
    case EnrollmentEventType.RE_ENROLLMENT:
      return React.createElement(UserPlus, { className: "h-4 w-4 mr-1" });
    default:
      return React.createElement(Info, { className: "h-4 w-4 mr-1" });
  }
};

export const getEventTitle = (event: any) => {
  switch (event.eventType) {
    case EnrollmentEventType.NEW_ENROLLMENT:
      return `Enrolled in ${event.details.programTitle}`;
    case EnrollmentEventType.PROGRAM_TRANSFER:
      return `Transferred from ${event.details.fromProgram?.title} to ${event.details.toProgram?.title}`;
    case EnrollmentEventType.STATUS_CHANGE:
      return `Status changed from ${event.details.previousStatus} to ${event.details.newStatus}`;
    case EnrollmentEventType.WITHDRAWAL:
      return `Withdrawn from ${event.details.programTitle}`;
    case EnrollmentEventType.RE_ENROLLMENT:
      return `Re-enrolled in ${event.details.programTitle}`;
    default:
      return 'Enrollment event';
  }
};

export const getEventBadgeVariant = (eventType: EnrollmentEventType) => {
  switch (eventType) {
    case EnrollmentEventType.NEW_ENROLLMENT:
      return 'default';
    case EnrollmentEventType.PROGRAM_TRANSFER:
      return 'outline';
    case EnrollmentEventType.STATUS_CHANGE:
      return 'secondary';
    case EnrollmentEventType.WITHDRAWAL:
      return 'destructive';
    case EnrollmentEventType.RE_ENROLLMENT:
      return 'default';
    default:
      return 'default';
  }
};
